import PropTypes from 'prop-types'
import React from 'react'
import {
  CarePlanSectionContent,
  CarePlanSectionHeader
} from '../../../../../components/carePlans'

export default function InitialAssessmentPreview({
  initialAssessment,
  testId
}) {
  return (
    <div
      data-testid={
        testId
          ? `${testId}-initial-assessment-preview`
          : 'initial-assessment-preview'
      }
    >
      <Section
        title="Strengths"
        content={initialAssessment.strengths || ''}
        testId={testId}
      />
      <Section
        title="Needs"
        content={initialAssessment.needs || ''}
        testId={testId}
      />
    </div>
  )
}

const Section = ({ title, content, testId }) => (
  <div
    style={styles.sectionContainer}
    data-testid={
      testId
        ? `${testId}-initial-assessment-section-${title.toLowerCase()}`
        : `initial-assessment-section-${title.toLowerCase()}`
    }
  >
    <CarePlanSectionHeader title={title} />
    <CarePlanSectionContent value={content} />
  </div>
)

const styles = {
  sectionContainer: {
    paddingTop: 55
  }
}

InitialAssessmentPreview.propTypes = {
  initialAssessment: PropTypes.object.isRequired,
  testId: PropTypes.string
}
